<template>
  <div class="content">
    <h2 class="has-text-centered">Våra favoriter</h2>
    <div v-for="(user, index) in topFavoriteList" :key="index">
      <user-beers :user="user" />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import UserBeers from './UserBeers'

export default {
  components: {UserBeers},
  data () {
    return {
    }
  },
  computed: {
    topFavoriteList: function () {
      let names = this.$store.getters.raters
      let topList = []

      names.forEach(name => {
        let result = this.$store.getters.data
        let query = name.toLowerCase()
        let userData = []
        let userBeers = []

        userData = result.filter(item => {
          return item.raters.some(rater => {
            return rater.indexOf(query) === 0
          })
        })

        userData.forEach(b => {
          userBeers.push({
            name: b.name,
            average: b.average,
            rating: b.ratings[name].rating
          })
        })

        userBeers = _.orderBy(userBeers, 'rating', 'desc')

        topList.push({
          name: name,
          data: userBeers
        })
      })

      return topList
    }
  }
}
</script>

<style lang="scss">
.top-favorite__rating {
  width: 90px;
}
</style>



// WEBPACK FOOTER //
// TopFavorites.vue?3d595efa